import styled, { css } from 'styled-components';

import { IconButton } from '@mui/material';

import { ModuleWrapperProps } from './types';

export const Wrapper = styled.main`
  display: flex;

  width: 100vw;
  max-width: 100vw;
  height: 100vh;
  max-height: 100vh;
`;

export const VideoContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;

  iframe {
    width: 100%;
    height: 100%;
    max-width: 100%;
  }
`;

export const ExpandModuleButton = styled(IconButton)`
  ${({ theme }) => css`
    height: ${theme.spacing(3)};
    width: ${theme.spacing(3)};

    margin-top: ${theme.yoga.spacing.xsmall}px;

    svg {
      fill: ${theme.yoga.colors.primary};
    }
  `}
`;

export const ModuleWrapper = styled.div<ModuleWrapperProps>`
  ${({ theme, isExpanded = false }) => css`
    display: flex;
    justify-content: center;
    background-color: ${theme.yoga.colors.white};

    width: ${isExpanded ? '450px' : '44px'};

    @media screen and (max-width: 1024px) {
      max-width: 100vw;
    }
  `}
`;
